@if (!emailsQuery.data() || emailsQuery.data().length === 0) {
<div class="flex flex-col w-full justify-start items-center">

    @if (emailsQuery.isLoading()) {
    <p class="text-muted py-16">Emails loading</p>
    }
    @if (emailsQuery.isError()) {
    <p class="text-muted py-16">Error loading emails</p>
    }
    @if (emailsQuery.isSuccess() && emailsQuery.data().length === 0) {
    <p class="text-muted py-16">No emails found</p>
    }
</div>
} @else {
<table mat-table [dataSource]="datasource()" class="w-full">
    <ng-container matColumnDef="combined">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let email">
            <div class="flex flex-row justify-start items-center">
                <div class="flex flex-col justify-start items-start basis-full">
                    @if (linkToDocket) {
                    <app-docket-link [email]="email"></app-docket-link>
                    }
                    <p>Subject: {{email.subject}}</p>
                    <p><small>Sent by {{ email.user_id | userIdToName | async }}</small> on {{email.created_at |
                        amDateFormat:
                        dateFormat}}</p>
                </div>
                <div class="flex flex-col justify-center items-center">
                    <app-status-icon [email]="email"></app-status-icon>
                    <button mat-icon-button (click)="downloadEmail(email.link)" matTooltip="Download email">
                        <mat-icon>download</mat-icon>
                    </button>
                </div>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="linkToDocket">
        <th mat-header-cell *matHeaderCellDef> Source </th>
        <td mat-cell *matCellDef="let email"><app-docket-link [email]="email"></app-docket-link></td>
    </ng-container>
    <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef> Subject </th>
        <td mat-cell *matCellDef="let email"> {{email.subject}} </td>
    </ng-container>

    <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef> Sent By </th>
        <td mat-cell *matCellDef="let email"> {{ email.user_id | userIdToName | async }}
        </td>
    </ng-container>

    <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef> To </th>
        <td mat-cell *matCellDef="let email"> {{email.to}} </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef> Sent </th>
        <td mat-cell *matCellDef="let email"> {{email.created_at | amDateFormat:dateFormat}} </td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let email"> <app-status-icon [email]="email"></app-status-icon></td>
    </ng-container>

    <ng-container matColumnDef="link">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let email">
            <button mat-icon-button (click)="downloadEmail(email.link)" matTooltip="Download email">
                <mat-icon>download</mat-icon>
            </button>

        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns()"></tr>
    <tr mat-row *matRowDef="let row; columns: columns();"></tr>

</table>
<mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of emails">
</mat-paginator>
}